import React, { useId, useState } from "react";
import { Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { PermissionDTO } from "../../auth/context/useAuthContext";
import {
  getPermissionPresentation,
  PermissionAccountType,
} from "./permissionPresentation";
import "./PermissionItem.css";

export interface PermissionItemProps {
  permission: PermissionDTO;
  checked: boolean;
  onChange: () => void;
  type?: PermissionAccountType;
  changeStatus?: "added" | "removed";
}

export const PermissionItem = ({
  permission,
  checked,
  onChange,
  type = "Admin",
  changeStatus,
}: PermissionItemProps) => {
  const descriptionId = useId();
  const [expanded, setExpanded] = useState(false);
  const presentation = getPermissionPresentation(permission, type);
  const hasDetails = type === "Admin";
  const showPreviousTitle = hasDetails && permission.displayName !== presentation.title;
  const statusNotice = presentation.statusNotice || (presentation.needsReview ? "연결 확인 필요" : undefined);

  return (
    <div className="permission-item">
      <div className="permission-item__heading">
        <Checkbox
          checked={checked}
          onChange={onChange}
          aria-describedby={hasDetails && expanded ? descriptionId : undefined}
        >
          <span className="permission-item__title">{presentation.title}</span>
          {showPreviousTitle && (
            <span className="permission-item__previous-title">
              {" "}({permission.displayName})
            </span>
          )}
        </Checkbox>
        {hasDetails && (
          <button
            type="button"
            className="permission-item__expand"
            aria-label={`${presentation.title} 권한 상세 정보`}
            aria-expanded={expanded}
            aria-controls={descriptionId}
            onClick={() => setExpanded((previous) => !previous)}
          >
            <DownOutlined aria-hidden="true" />
          </button>
        )}
      </div>
      {changeStatus && (
        <div className="permission-item__badges">
          <span className="permission-item__change-status">
            {changeStatus === "added" ? "추가 예정" : "제거 예정"}
          </span>
        </div>
      )}
      {hasDetails && (
        <div
          id={descriptionId}
          className="permission-item__description"
          role="region"
          aria-label={`${presentation.title} 권한 설명`}
          hidden={!expanded}
        >
          {statusNotice && (
            <p className="permission-item__review-notice">{statusNotice}</p>
          )}
          {presentation.description && <p>{presentation.description}</p>}
          {presentation.prerequisite && (
            <p>
              <strong>함께 필요: </strong>
              {presentation.prerequisite}
            </p>
          )}
          {presentation.scopeNote && (
            <p>
              <strong>적용 범위: </strong>
              {presentation.scopeNote}
            </p>
          )}
          <p className="permission-item__key">권한 키: {permission.name}</p>
        </div>
      )}
    </div>
  );
};
